import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { mdiLoading } from "@mdi/js";

import { Svg } from "./Svg";

const LoadProgressStyle = styled.div`
    width: 100%;
    height: 250px;
    margin-top: 30px;
    text-align: center;
    color: ${props => props.theme.primaryLighter};
`;

export const LazyScroll = props => {

    const { id, loadMore, hasMore, threshold = 500, children } = props;

    const options = { passive: true };
    const thresholdPx = Number(threshold);

    const loadingRef = useRef(false);
    const parentElementRef = useRef(null);
    const scrollComponentRef = useRef(null);

    const [pageNum, setPageNum] = useState(0);

    useEffect(() => {
        const scrollEl = getParentElement();
        if (!hasMore || !scrollEl) {
            return undefined;
        }
        const onScroll = async () => {
            const el = scrollComponentRef.current;
            const parentNode = getParentElement();
            if (!el || !parentNode) {
                return;
            }
            const offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
            if (!loadingRef.current && offset <= thresholdPx && el.offsetParent !== null) {
                loadingRef.current = true;
                scrollEl.removeEventListener("scroll", onScroll, options);
                try {
                    await loadMore();
                } finally {
                    loadingRef.current = false;
                    setPageNum(prevPageNum => prevPageNum + 1);
                }
            }
        };
        scrollEl.addEventListener("scroll", onScroll, options);
        return () => {
            scrollEl.removeEventListener("scroll", onScroll, options);
        };
    }, [hasMore, loadMore, pageNum, thresholdPx]);

    const getParentElement = () => {
        const el = scrollComponentRef.current;
        if (el && el.parentNode) {
            parentElementRef.current = el.parentNode;
        }
        return parentElementRef.current;
    };

    return (
        <div id={id} ref={scrollComponentRef}>
            {children}
            {hasMore &&
                <LoadProgressStyle>
                    <Svg path={mdiLoading} loading={true} size="40" />
                </LoadProgressStyle>
            }
        </div>
    );
};